import { helpbuttonStyle } from '@bingads-webui-campaign-react/common-styles';

export const getStyles = (_, core) => ({
  criterionSettingContainer: {
    '& .helpbutton': helpbuttonStyle(core)['.helpbutton'],
    '& .helpbutton::before': helpbuttonStyle(core)['.helpbutton::before'],
    '& .control-label': {
      paddingBottom: '0px',
    },
    '& .target-toggle': {
      '& .ms-Toggle-label': {
        fontWeight: 400,
      },
    },

    '& .table-container': {
      width: '716px',
      '&.length-of-stay-container,&.checkin-date-container': {
        width: '890px',
      },
      '& .bid-adjustment-input': {
        width: '66px',
      },
      '& .criterion-target-table': {
        '& .ms-List-cell': {
          minHeight: '0',
        },
        '& .ms-DetailsHeader': {
          paddingTop: 0,
          paddingBottom: 0,
          borderTop: `1px solid ${core.palette.neutralLight}`,
          '& .ms-DetailsHeader-cellName': {
            fontWeight: 'normal',
          },
        },
        '& .ms-DetailsRow': {
          animationFillMode: 'none',
        },
        '& .ms-DetailsRow:hover,& .ms-DetailsHeader-cell:hover': {
          backgroundColor: `${core.palette.white}`,
          color: 'inherit',
          '& .ms-DetailsRow-cell .ms-Link.is-disabled': {
            color: `${core.palette.neutralTertiary}`,
          },
        },
        '& .target-remove-btn': {
          fontSize: '14px',
        },
        '& .target-custom-header': {
          borderRight: `1px solid ${core.palette.neutralLight}`,
        },
        '& .ms-DetailsRow-cell': {
          paddingTop: '5px',
          paddingBottom: '5px',
          lineHeight: '30px',
        },
        '& .border-right': {
          borderRight: `1px solid ${core.palette.neutralLight}`,
        },
      },
      '& .ms-TextField-fieldGroup::after': {
        border: '0px',
      },
    },
    '& .target-add-btn': {
      marginTop: '12px',
    },
    '& .green-dot label': {
      '&:before': {
        width: '10px',
        height: '10px',
        borderRadius: '5px',
        display: 'inline-block',
        content: '""',
        backgroundColor: `${core.palette.green}`,
        marginRight: '5px',
      },
    },
    '& input:focus': {
      outline: 'none',
    },
    '& .input-error-border .ms-TextField-fieldGroup': {
      borderColor: `${core.semanticColors && core.semanticColors.errorIcon}`,
    },

  },
});
